export default "__VITE_ASSET__AmpqvDhj__"